"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    overflow: hidden;\n    text-overflow: ellipsis;\n    width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TextWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.issuer ? "calc(100% - ".concat(props.theme.palette.gutter + 24, "px)") : 'auto';
});

var _default = TextWrapper;
exports["default"] = _default;